export const environment = {
	production: false,
	environment: 'uat',
	auth: {
		clientId: 'b964fe48-e387-473f-9a32-22cdd632bfa9',
		authority: 'https://login.microsoftonline.com/76b5b304-4736-44dc-ba8c-944e061047eb',
		redirectUri: 'https://raptest.dnv.org/',
		logoutUri: 'https://raptest.dnv.org/',
		piiLoggingEnabled: false,
	},
	webApiUrl: 'https://raptest.dnv.org/',
	geotoolsUrl: 'https://gttest.dnv.org/',
	syncfusionLicenseKey: 'ORg4AjUWIQA/Gnt3VVhhQlJDfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5adkZiUH9ac3FWQWBZWkd+'
};
